export default __webpack_public_path__ + "images/df188609bd384abde188f2a129a7ef95-food_sub.jpg";